import { Stage } from "./Stage";
import { Speech } from "./TalkPanel";

export class Stage5 extends Stage {
    constructor() {
        super();
        this.pushCheckPoint(50, 50);
        this.pushPlayer(50, 50);
        this.asCameraCenter();

        this.pushWall(-400, -200, 200, 600);
        this.pushWall(-400, -400, 400, 200);
        this.pushWall(200, -400, 400, 200);
        this.pushWall(400, -200, 200, 600);
        this.pushWall(-400, 400, 1000, 200);
        this.pushWall(-800, 0, 400, 200);
        this.pushWall(-800, -600, 200, 600);
        this.pushWall(-800, -800, 1800, 200);
        this.pushWall(800, -600, 200, 800);
        this.pushWall(400, -1200, 200, 400);
        this.pushWall(600, -1600, 200, 600);
        this.pushWall(800, -1200, 600, 200);
        this.pushWall(1200, -1000, 200, 1200);
        this.pushWall(1400, -600, 400, 200);
        this.pushWall(1600, -400, 200, 2000);
        this.pushWall(1400, 1200, 200, 200);
        this.pushWall(800, 1600, 1000, 200);
        this.pushWall(800, 1800, 200, 400);
        this.pushWall(600, 2200, 400, 200);
        this.pushWall(400, 1600, 200, 1200);
        this.pushWall(200, 1200, 400, 200);
        this.pushSquare(600, 1200, 200, 200);
        this.pushSquare(600, 1400, 200, 600);
        this.pushFakePanel(800, 1400, 400, 200);
        this.pushWall(800, 1200, 400, 200);
        this.pushWall(800, 1000, 200, 200);
        this.pushWall(800, 400, 600, 600);
        this.pushFakePanel(600, 400, 200, 200);
        this.pushFakePanel(1400, -400, 200, 600);
        this.pushSquare(1400, 200, 200, 600);
        this.pushSquare(-600, 600, 800, 200);
        this.pushWall(-800, 800, 1600, 200);
        this.pushFakePanel(-1000, 800, 200, 400);
        this.pushWall(-1200, 1200, 1200, 200);
        this.pushWall(-600, 1400, 400, 600);
        this.pushFakePanel(-200, 1400, 200, 600);
        this.pushWall(0, 1600, 200, 400);
        this.pushSquare(200, 1600, 200, 600);
        this.pushSquare(0, 2000, 200, 200);
        this.pushSquare(-400, 2000, 400, 200);
        this.pushWall(-800, 2000, 200, 400);
        this.pushWall(-600, 2200, 400, 200);
        this.pushWall(0, 2200, 200, 600);
        this.pushWall(-400, 2800, 1000, 200);
        this.pushWall(-1200, 2600, 1000, 200);
        this.pushWall(-1200, 2200, 200, 400);
        this.pushWall(-1400, 2000, 400, 200);
        this.pushWall(-2000, 1800, 800, 200);
        this.pushFakePanel(-1600, 1600, 400, 200);
        this.pushWall(-1600, 1200, 400, 400);
        this.pushWall(-1600, 1000, 200, 200);
        this.pushWall(-1400, 800, 400, 200);
        this.pushWall(-1800, 700, 400, 300);
        this.pushWall(-1600, 200, 200, 200);
        this.pushWall(-1600, 400, 400, 100);
        this.pushWall(-1200, 400, 600, 200);
        this.pushWall(-1200, -200, 200, 600);
        this.pushSquare(-1200, -400, 200, 200);
        this.pushSquare(-1600, -400, 400, 200);
        this.pushFakePanel(-1400, -200, 200, 200);
        this.pushWall(-1800, -200, 400, 200);
        this.pushWall(-2000, -400, 200, 2200);
        this.pushWall(-2000, -600, 600, 200);
        this.pushWall(-1600, -1000, 200, 400);
        this.pushWall(-1600, -1200, 1600, 200);
        this.pushWall(-1200, -800, 200, 400);
        this.pushWall(-400, -1600, 200, 400);
        this.pushWall(-400, -1800, 1200, 200);
        this.pushSquare(0, -1400, 200, 600);
        this.pushWall(200, 600, 200, 25);
        this.pushWall(200, 775, 200, 25);

        this.pushSignboard(650, -950, [
            new Speech({
                content: "頑張ってください。",
                speakerName: "看板",
            }),
            new Speech({
                content: "ヒントとかではなくなってしまったか。",
            }),
            new Speech({
                content: "今回は大変そうね。",
                speakerName: "謎の声",
            }),
        ]);
        this.pushSignboard(250, -950, [
            new Speech({
                content: '<font style="color:#dd0000">自分の名前の読みには動物が隠れている。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(-1350, 1050, [
            new Speech({
                content: "頑張ってください。",
                speakerName: "看板",
            }),
            new Speech({
                content: "いま頑張っているよ。",
            }),
            new Speech({
                content: "とはいえもうすぐのようね。",
                speakerName: "謎の声",
            }),
        ]);
        this.pushSignboard(1050, 1050, [
            new Speech({
                content: '<font style="color:#dd0000">自分の名前には正という字が入っている。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(-1750, 1050, [
            new Speech({
                content: '<font style="color:#dd0000">自分の名前の読みには小さいひらがなが入っている。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);

        this.pushGoal(-950, 1650, 100, 100);

        // this.pushCheckPoint(700, -200);
        // this.respawnCheckPoint(1);

        this.create();
    }

    protected loop(): void {}
}
